import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import * as am4core from "@amcharts/amcharts4/core" ;
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_material from "@amcharts/amcharts4/themes/material";
import am4themes_dark from "@amcharts/amcharts4/themes/dark";
import am4themes_microchart from "@amcharts/amcharts4/themes/microchart";
import {XYChart} from "@amcharts/amcharts4/charts";
import {Container} from "@amcharts/amcharts4/core";

declare let ko: any;
declare let AmCharts: any;

export class amCharts_v4_date_line_template extends vnTemplate{


    protected getTemplateHtml(): string{

        return `<div data-bind="attr: {id: idChart}, style: {width: cssWidth, height: cssHeight, display: 'block' }"></div>`;
    }

    public getTemplateName(): string{
        return "amCharts_v4_date_line_template";
    }

    protected buildViewModel(): any{

        let _this = this;
        return  {
            idChart: ko.observable("chartDiv_" + _this.idElement),
            date: ko.observable(),
            cssWidth: ko.observable("98%"),
            cssHeight: ko.observable("470px"),
            xAxisRotation: ko.observable(0),
            xAxisFontSize: ko.observable(10),
            seriesTooltipFormat: ko.observable("{name}: [bold]{valueY}[/]"),
            show: ko.observable(false),
            yaxis: ko.observableArray([]),
            ranges: ko.observableArray([]),
            showGrid: ko.observable(false),
            interval: ko.observableArray([
                { timeUnit: "minute", count: 5 },
                { timeUnit: "minute", count: 30 },
                { timeUnit: "hour", count: 1 }
            ]),
            minGridDistance: ko.observable(1),
            show6HrsInterval: ko.observable(false)
        };
    }

    protected getMainElementClasses(): Array<string>{
        return ["graph"];
    }

    public setXAxisRotation(rotation: number): void {
        this.getTemplateViewModel().xAxisRotation(rotation);
    }


    public setXAxisFontSize(rotation: number): void {
        this.getTemplateViewModel().xAxisFontSize(rotation);
    }

    public setSeriesTooltipFormat(tooltipFormat: string): void {
        this.getTemplateViewModel().seriesTooltipFormat(tooltipFormat);
    }


    public setDate(date) {
        this.getTemplateViewModel().date(date);
    }

    public setMinGridDistance(minGridDistance){
        this.getTemplateViewModel().minGridDistance(minGridDistance);
    }

    public setInterval(interval) {
        this.getTemplateViewModel().interval(interval);
    }

    public setYaxis(axis) {
        this.getTemplateViewModel().yaxis(axis);
    }

    public setRanges(ranges) {
        this.getTemplateViewModel().ranges(ranges);
    }

    public show(): void {
        this.getTemplateViewModel().show(true);
    }

    public hide(): void {
        this.getTemplateViewModel().show(false);
    }

    public setShowGrid(showGrid){
        this.getTemplateViewModel().showGrid(showGrid);
    }

    public setShow6HrsInterval(show6HrsInterval){
        this.getTemplateViewModel().show6HrsInterval(show6HrsInterval);
    }

    public drawChart(chartData) {

        let _this = this;

        am4core.disposeAllCharts();
        am4core.unuseAllThemes();
        am4core.useTheme(am4themes_animated);
        am4core.options.autoDispose = true;

        // Create chart instance
        let chart = am4core.create("chartDiv_" + _this.idElement, am4charts.XYChart);

        //remove logo
        if(chart.logo){

            chart.logo.disabled = true;
        }

        // Increase contrast by taking evey second color
        //chart.colors.step = 2;

        // Add data
        chart.data = chartData;

        // Create axes
        let xAxis = chart.xAxes.push(new am4charts.DateAxis());
        xAxis.skipEmptyPeriods = false;
        xAxis.groupData = true;

        xAxis.groupIntervals.setAll(this.getTemplateViewModel().interval());

        xAxis.dateFormatter = new am4core.DateFormatter();
        xAxis.dateFormatter.dateFormat = "yyyy-MMMM-dd HH:mm";
        xAxis.dateFormats.setKey("day", "MMMM-dd HH:mm");
        xAxis.periodChangeDateFormats.setKey("day", "MMMM-dd HH:mm");
        xAxis.dateFormats.setKey("hour", "MMMM-dd HH:mm");
        xAxis.periodChangeDateFormats.setKey("hour", "MMMM-dd HH:mm");
        xAxis.dateFormats.setKey("minute", "HH:mm");
        xAxis.periodChangeDateFormats.setKey("minute", "HH:mm");
        xAxis.renderer.grid.template.location = 0;
        xAxis.renderer.minGridDistance = 20;
        xAxis.renderer.labels.template.rotation = this.getTemplateViewModel().xAxisRotation();
        xAxis.renderer.labels.template.verticalCenter = "middle";
        xAxis.renderer.labels.template.fontSize = this.getTemplateViewModel().xAxisFontSize();
        xAxis.tooltipDateFormat = "MM-dd HH:mm";
        xAxis.snapTooltip = false;

        xAxis.baseInterval = {
            "timeUnit": "minute",
            "count": 5
        };

        const VALID_LABEL_VALUES = ["06:00", "12:00", "18:00", "00:00"];

        if(this.getTemplateViewModel().show6HrsInterval()){
            chart.events.once("ready", function () {
                let labels = xAxis.renderer.labels.values;
                labels.forEach(label => {
                    let labelTextValue = label.currentText;
                    let hours = label.currentText.split(" ")[1];
                    
                    label.visible = labelTextValue == VALID_LABEL_VALUES[0] || labelTextValue == VALID_LABEL_VALUES[1] || labelTextValue == VALID_LABEL_VALUES[2] || labelTextValue == VALID_LABEL_VALUES[3]
                    || hours == VALID_LABEL_VALUES[0]|| hours == VALID_LABEL_VALUES[1] || hours == VALID_LABEL_VALUES[2] || hours == VALID_LABEL_VALUES[3];           
                });
            });
        }
        // when data is zoomed in/out keep specific label visible
        xAxis.events.on("datarangechanged", function (event) {
            let labels = xAxis.renderer.labels.values;

            labels.forEach(function (label) {
                let labelTextValue = label.currentText;
                let hours;
                if (labelTextValue) {
                    hours = labelTextValue.split(" ")[1];
                }

                label.visible = labelTextValue == VALID_LABEL_VALUES[0] || labelTextValue == VALID_LABEL_VALUES[1] || labelTextValue == VALID_LABEL_VALUES[2] || labelTextValue == VALID_LABEL_VALUES[3]
                || hours == VALID_LABEL_VALUES[0]|| hours == VALID_LABEL_VALUES[1] || hours == VALID_LABEL_VALUES[2] || hours == VALID_LABEL_VALUES[3];
            });
        });

        let yAxis = [];
        for (let axis of this.getTemplateViewModel().yaxis()) {

            if (typeof yAxis[axis.axis] === 'undefined') {
                yAxis[axis.axis] = chart.yAxes.push(new am4charts.ValueAxis());

                // Percent axes (e.g. Scroll Depth %) are bounded 0-100.
                if (axis.isPercent) {
                    yAxis[axis.axis].min = 0;
                    yAxis[axis.axis].max = 100;
                    yAxis[axis.axis].strictMinMax = true;
                }
            }

            let series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.valueY = axis.field;
            // Percent series average across grouped buckets; counts still sum.
            series.groupFields.valueY = axis.groupAggregation ? axis.groupAggregation : "sum";
            series.dataFields.dateX = this.getTemplateViewModel().date();
            series.strokeWidth = 3;
            // Series whose data only covers some hours (e.g. per-device engagement)
            // bridge null gaps to draw one continuous line that follows the same
            // path as the blended series, instead of fragmented segments. amCharts
            // links the surrounding non-null points directly, so this is accurate.
            if (typeof axis.connect !== 'undefined') {
                series.connect = axis.connect;
            }
            series.fill = am4core.color(axis.color);
            series.stroke = am4core.color(axis.color);
            series.yAxis = yAxis[axis.axis];
            series.name = axis.name;
            series.showOnInit = true;

            if(axis.calculatePercent){

                series.adapter.add('tooltipText', (text, target) => {

                    let data = null;
                    if(target && target.tooltipDataItem){

                        //@ts-ignore
                        data = target.tooltipDataItem.groupDataItems;
                        if(!data){
                            data = [target.tooltipDataItem];
                        }
                    }

                    if (data) {
                        let value = 0;
                        let groupViewTotal = 0;
                        let groupDepthTotal = 0;

                        for(let item of data){
                            groupViewTotal += item.dataContext.viewCount;
                            groupDepthTotal += item.dataContext.depthMarkerCount;
                        }

                        if(groupViewTotal > 0){
                            value = (groupDepthTotal * 100 / groupViewTotal);
                        }else{
                            value = (groupDepthTotal * 100);
                        }

                        return "{name}: [bold]{valueY} (" + value.toFixed(1) + "%)[/]";
                    }
                    else {
                        return "{name}: [bold]{valueY} ({engagementRate}%)[/]";
                    }
                });
            }else{
                series.tooltipText = axis.tooltipText ? axis.tooltipText : this.getTemplateViewModel().seriesTooltipFormat();
            }

            let interfaceColors = new am4core.InterfaceColorSet();

            let bullet = null;
            let square = null;
            switch (axis.bullet){

                case "diamond":
                    bullet = series.bullets.push(new am4charts.Bullet());
                    square = bullet.createChild(am4core.Rectangle);
                    square.width = 10;
                    square.height = 10;
                    square.horizontalCenter = "middle";
                    square.verticalCenter = "middle";
                    square.rotation = 45;
                    break;
                case "square":
                    bullet = series.bullets.push(new am4charts.Bullet());
                    square = bullet.createChild(am4core.Rectangle);
                    square.width = 10;
                    square.height = 10;
                    square.horizontalCenter = "middle";
                    square.verticalCenter = "middle";
                    break;
                case "circle":
                    bullet = series.bullets.push(new am4charts.CircleBullet());
                    bullet.circle.stroke = interfaceColors.getFor("background");
                    bullet.circle.strokeWidth = 2;
                    break;
                case "none":
                    break;
                default:
                    bullet = series.bullets.push(new am4charts.CircleBullet());
                    bullet.circle.stroke = interfaceColors.getFor("background");
                    bullet.circle.strokeWidth = 2;
            }

            yAxis[axis.axis].renderer.line.strokeOpacity = 1;
            yAxis[axis.axis].renderer.line.strokeWidth = 2;
            yAxis[axis.axis].renderer.line.stroke = series.stroke;
            yAxis[axis.axis].renderer.labels.template.fill = series.stroke;
            yAxis[axis.axis].renderer.opposite = axis.opposite;
        }

        for (let range of this.getTemplateViewModel().ranges()) {

            let dateRange = xAxis.axisRanges.create();
            dateRange.date = new Date(range.publishDate);
            switch (range.publishType){
                case "first":
                    dateRange.grid.stroke = am4core.color("red");
                    break;
                case "republish":
                    dateRange.grid.stroke = am4core.color("#01bfd5");
                    break;
                default:
                    dateRange.grid.stroke = am4core.color("red");
            }

            dateRange.grid.strokeWidth = 2;
            dateRange.grid.strokeOpacity = 1;
        }

        // Add legend
        chart.legend = new am4charts.Legend();
        chart.paddingLeft = 0;
        chart.paddingRight = 26;        
        chart.paddingBottom = 0;        
        chart.paddingTop = 5;        

        // External Legend
        let legendContainer = am4core.create("legenddiv", am4core.Container);
        legendContainer.width = am4core.percent(100);
        legendContainer.height = am4core.percent(100);
        chart.legend.parent = legendContainer;
        chart.legend.parent.logo.disabled = true;

        // Size the external legend div to exactly the legend's content so it does not
        // reserve empty space between the legend and the chart (amCharts' default fills
        // its container, which leaves a large gap when there are only a few items).
        chart.legend.events.on("datavalidated", () => {
            const legendDiv = document.getElementById("legenddiv");
            if (legendDiv) {
                legendDiv.style.height = (chart.legend.contentHeight + 4) + "px";
            }
        });

        // Add cursor
        chart.cursor = new am4charts.XYCursor();
    }

    async drawListCharts(tableData, batchEnabled = false) {
        return new Promise(async (resolve, reject) => {
            const element = document.getElementById(this.idElement);
            if (!element) {
                //reject(new Error("Element not found."));
                return;
            }
            this.clearChart();
            this.configureChartTheme();
            const chart = this.createXYChart();

            if (!chart) {
                reject(new Error("Failed to create chart."));
                return;
            }

            this.configureXAxis(chart);
            const yAxisConfigs = this.getTemplateViewModel().yaxis();
            if (!yAxisConfigs.length) {
                reject(new Error("No Y-axis configurations found."));
                return;
            }

            try {
                await this.createYAxesAndSeries(chart, yAxisConfigs);
                await this.processNextChart(tableData, chart, 0, batchEnabled);
                resolve(chart); // Resolve with the chart when all operations are complete.
            } catch (error) {
                reject(error); // Reject with any error that occurred during the async operations.
            }
        });
    }


    private createYAxesAndSeries(chart: XYChart, yAxisConfigs: any) {
        const yAxes = [];
        for (const config of yAxisConfigs) {
            if (typeof yAxes[config.axis] === "undefined") {
                yAxes[config.axis] = chart.yAxes.push(new am4charts.ValueAxis());
            }

            const series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.valueY = config.field;
            series.groupFields.valueY = "sum";
            series.dataFields.dateX = this.getTemplateViewModel().date();
            series.strokeWidth = 2;
            series.fill = am4core.color(config.color);
            series.stroke = am4core.color(config.color);
            series.yAxis = yAxes[config.axis];
            series.name = config.name;
            series.fillOpacity = 0.6;
            series.showOnInit = true;

            yAxes[config.axis].renderer.line.strokeOpacity = 1;
            yAxes[config.axis].renderer.line.strokeWidth = 2;
            yAxes[config.axis].renderer.line.stroke = series.stroke;
            yAxes[config.axis].renderer.labels.template.fill = series.stroke;
            yAxes[config.axis].renderer.opposite = config.opposite;
            yAxes[config.axis].renderer.labels.template.fontSize = 35;
        }
    }

    private configureXAxis(chart: XYChart) {
        const xAxis = chart.xAxes.push(new am4charts.DateAxis());
        xAxis.skipEmptyPeriods = false;
        xAxis.groupData = true;

        xAxis.groupIntervals.setAll(this.getTemplateViewModel().interval());

        xAxis.dateFormatter = new am4core.DateFormatter();
        xAxis.dateFormatter.dateFormat = "yyyy-MMMM-dd HH:mm";
        xAxis.dateFormats.setKey("day", "MMMM-dd HH:mm");
        xAxis.periodChangeDateFormats.setKey("day", "MMMM-dd HH:mm");
        xAxis.dateFormats.setKey("hour", "MMMM-dd HH:mm");
        xAxis.periodChangeDateFormats.setKey("hour", "MMMM-dd HH:mm");
        xAxis.dateFormats.setKey("minute", "HH:mm");
        xAxis.periodChangeDateFormats.setKey("minute", "HH:mm");
        xAxis.renderer.grid.template.location = 0;
        xAxis.renderer.minGridDistance = 20;
        xAxis.renderer.labels.template.rotation =
            this.getTemplateViewModel().xAxisRotation();
        xAxis.renderer.labels.template.verticalCenter = "middle";
        xAxis.renderer.labels.template.disabled = true;
        xAxis.tooltipDateFormat = "MM-dd HH:mm";
        xAxis.snapTooltip = false;

        xAxis.baseInterval = {
            timeUnit: "minute",
            count: 5,
        };
    }

    private createXYChart() {
        const chart = am4core.create(this.idElement, am4charts.XYChart);
        if (chart) {
            chart.svgContainer.autoResize = false;
            chart.svgContainer.measure();
            if(chart.logo){ chart.logo.disabled = true }
            if(chart.zoomOutButton){ chart.zoomOutButton.disabled = true}
            chart.maskBullets = false;
        }
        return chart;
    }

    private configureChartTheme() {
        const theme = this.getTemplateViewModel().showGrid()
            ? am4themes_material
            : am4themes_microchart;
        am4core.useTheme(theme);
    }

    private clearChart() {
        const charts = this.getAllCurrentCharts()
        for (let i = 0; i < charts.length; i++) {
            if (!(charts[i] instanceof am4charts.XYChart)) {
                charts[i].dispose();
            }
        }
        //am4core.disposeAllCharts();
        am4core.unuseAllThemes();
        am4core.options.autoDispose = true;
    }

    private getAllCurrentCharts() {
       return am4core.registry.baseSprites
    }


    public processNextChart(tableData, chart, index = 0, batchEnabled? : boolean): Promise<void> {
        return new Promise((resolve, reject) => {
            let chartData = tableData[index];
            if (chartData) {
                if (!chartData["data"]) {
                    resolve(this.processNextChart(tableData, chart, ++index, batchEnabled));
                    return;
                }

                chartData["republishDates"].forEach((element) => {
                    let dateRange = chart.xAxes.values[0].axisRanges.create();
                    dateRange.date = new Date(element["republishDate"]);
                    dateRange.grid.stroke = am4core.color("green");
                    dateRange.grid.strokeWidth = 2;
                    dateRange.grid.strokeOpacity = 1;
                });

                let idArticle = chartData["data"][0]["idArticle"];
                let idElement = "trend-" + idArticle;

                let lastSeries = null;
                for (let serie of chart.series) {
                    lastSeries = serie;
                }

                chart.data = chartData["data"];
                if(index == 0){
                    chart.events.once("ready",  () => {
                        resolve(this.createImage(tableData, chart, idElement, index, batchEnabled));
                    })
                }else{
                    lastSeries.events.once("dataitemsvalidated", () => {
                        resolve(this.createImage(tableData, chart, idElement, index, batchEnabled));
                    });
                }

            } else {
                let elementCheck = document.getElementById(this.idElement);
                if (elementCheck) chart.dispose();
                resolve();
            }
        });
    }

    public createImage(tableData, chart, idElement, index, batchEnabled? : boolean) {
        if(chart){
            let invalidSprites = am4core.registry.invalidSprites[chart.uid];
            if (invalidSprites && invalidSprites.length) {
                am4core.registry.events.once("exitframe", () => {
                    this.createImage(tableData, chart, idElement, index, batchEnabled);
                });
            } else {
                am4core.registry.events.once("exitframe", async () => {
                    let target = chart.chartAndLegendContainer;
                    let svg = chart.exporting.normalizeSVG(
                        chart.exporting.serializeElement(target.dom),
                        {},
                        target.pixelWidth,
                        target.pixelHeight,
                        1
                    );
                    let div = document.getElementById(idElement);
                    if (div) {
                        div.innerHTML = svg;
                    }
                    await this.processNextChart(tableData, chart, ++index, batchEnabled);
                    if (index == tableData.length) {
                        if (batchEnabled) {
                            this.removeLoadingClassAnimation();
                        }
                        if(batchEnabled == false) {
                            chart.dispose()
                        }
                    }
                })
            }
        }

    }

    private removeLoadingClassAnimation() {
        // Get all elements with the specified class name
        const elements = document.querySelectorAll('.is-batch-queued' );
        elements.forEach(function (element) {
            element.classList.remove('is-batch-queued');
        });
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/amCharts_v4_date_line_template.ts